import { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import "../styles/Register.css";

const Register = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.fullname || !formData.email || !formData.password) {
      setError("All fields are required");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/patient/patientregister`,
        formData,
      );
      alert(
        `Registration successful! Your Patient ID: ${response.data.patientId}`,
      );
      localStorage.setItem("patientId", response.data.patientId);
      localStorage.setItem("patientToken", response.data.token);
      navigate("/patient-dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred");
    }
  };

  return (
    <div className="background-container">
      <div className="register-form">
        <h2>Patient Registration</h2>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="fullname"
            placeholder="Full Name"
            value={formData.fullname}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
          />
          <input
            type="password"
            name="password"
            placeholder="Password (min. 8 characters)"
            value={formData.password}
            onChange={handleChange}
            minLength={8}
          />
          <button type="submit" className="register-buttons">
            Register
          </button>
        </form>
        <p>
          Already have an account? <Link to="/patient/login">Login here</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
